import React from "react"

export default function Cta() {
  return (
    <div className="bg-blue-100">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-24 lg:px-8 lg:flex lg:items-center lg:justify-between">
        <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 md:text-4xl">
          <span className="block">Ready to learn more?</span>
          <span className="block text-[#004fff]">
            Register for free access to exclusive content today.
          </span>
        </h2>
        <div className="mt-8 flex lg:mt-0 lg:flex-shrink-0">
          <div className="inline-flex rounded-md shadow">
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLScVBWSS5SQag3giz9o1qRiSjwH5GJfOTMJXp9-fPWSRPZCGWw/viewform"
              target="_blank"
              className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-[#004fff] hover:bg-blue-700"
            >
              Register Now
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
